export default "__VITE_ASSET__CVf3zrr7__"